module.exports = __webpack_public_path__ + "img/shortcode_before_after_1.e536d0db.png";